































import { Component, Vue, Watch } from "vue-property-decorator";

@Component
export default class Greeting extends Vue {
  private readerName = "";
  private allowedNames = ["pamela", "isabell"];

  private sound?: HTMLAudioElement;
  private audioStartTime = 0;

  mounted() {
    this.sound = this.$refs["keystroke-sound"] as HTMLAudioElement;
    this.sound.ontimeupdate = this.audioTimeUpdate;
  }

  private normalize(name: string): string {
    return name.toLowerCase().trim();
  }

  get readerNameState() {
    if (this.readerName.length > 0) {
      return this.allowedNames.includes(this.normalize(this.readerName));
    } else {
      return null;
    }
  }

  private audioTimeUpdate() {
    if (this.sound !== undefined) {
      if (this.sound.currentTime - this.audioStartTime > 0.5) {
        this.sound.pause();
      }
    }
  }

  private playCharacterSound() {
    if (this.sound !== undefined) {
      this.audioStartTime = Math.random() * (this.sound.duration - 1);
      this.sound.currentTime = this.audioStartTime;
      this.sound.play();
    }
  }

  @Watch("readerName")
  onReaderNameChanged(val: string, oldVal: string) {
    if (this.readerNameState === true) {
      this.$emit("readerName", this.normalize(this.readerName));
    }
  }
}
